// Image imports
import odedLifshitzPortrait from '../../../images/oded_lifshitz_portrait.jpg';

export const odedLifshitzMemorial = {
  id: 12,
  name: 'Oded Lifshitz',
  category: 'community-leaders',
  images: {
    portrait: odedLifshitzPortrait
  },
  info: `

# Oded Lifshitz

"A lifetime dedicated to peace, cut short by those who knew only violence." - Friends of Oded

![Oded Lifshitz](${odedLifshitzPortrait})
*Oded Lifshitz, a peace activist whose life was dedicated to coexistence*

## A Man of Principles

Oded Lifshitz was 84 years old when Hamas terrorists attacked Kibbutz Nir Oz on October 7th, 2023. Throughout his long life, he had been a tireless advocate for peace and coexistence between Israelis and Palestinians. He firmly believed that dialogue and understanding were the path forward, even when tensions were high.

Living near the Gaza border was a conscious choice for Oded. He wanted to be close to those he sought to help, to understand their struggles, and to build bridges where others saw only walls.

## A Lifetime of Advocacy

Oded's dedication to peace wasn't just talk - it was action. Together with his wife Judy Weinstein-Haggai, he spent decades working on humanitarian projects to help Palestinians in Gaza. They were known in their community for their unwavering commitment to human rights and dignity for all people, regardless of nationality or religion.

Friends remember Oded as a man who never lost hope, even in the darkest times. His smile was warm, his handshake firm, and his conviction unshakable. He would often say that peace requires courage - more courage than war - and he lived by those words every day.

## Tragic Irony

The cruel irony of Oded's death is not lost on those who knew him. A man who dedicated his life to building peace between Israelis and Palestinians was killed by the very people he had spent decades trying to help. Yet those who loved him insist that this tragedy only underscores the importance of his life's work.

As one friend put it:

> "Oded would be the first to remind us that violence only creates more suffering. Even now, especially now, he would urge us not to let hatred consume us."

## Remembering Oded

Oded was laid to rest on February 25th, 2025, one day before the Bibas family. His funeral was attended by peace activists from both Israel and Palestine - a testimony to the bridges he had built during his lifetime.

His wife Judy remains in captivity, reportedly among those murdered while held hostage. The pain of this dual tragedy is almost unbearable for those who loved them both.

As we remember Oded Lifshitz, we honor not just his life but his vision of a better future. A future where people recognize their shared humanity before their differences. A future where peace is more than just a dream.

May his memory inspire us to continue his work, to seek understanding where there is conflict, and to never lose hope even in the darkest times.

*Peace was your life's mission, Oded. May you now rest in the peace you sought for others.*

`
};